var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2863_33558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6491 12.8002C24.6491 19.2282 19.4211 24.4402 12.9691 24.4402C6.52106 24.4402 1.28906 19.2282 1.28906 12.8002C1.28906 6.37216 6.51706 1.16016 12.9691 1.16016C19.4171 1.16016 24.6491 6.37216 24.6491 12.8002Z",
    fill: "url(#paint0_linear_2863_33558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7137 31.1899C42.7137 37.6219 37.4817 42.8339 31.0297 42.8339C24.5777 42.8339 19.3457 37.6219 19.3457 31.1899C19.3457 24.7579 24.5777 19.5459 31.0297 19.5459C37.4817 19.5459 42.7137 24.7619 42.7137 31.1899Z",
    fill: "url(#paint1_linear_2863_33558)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33203 13.8018C1.86003 20.2298 7.50403 25.0098 13.928 24.4818C20.352 23.9538 25.136 18.3098 24.608 11.8818C24.152 6.37781 19.904 1.94181 14.42 1.25781C8.40003 3.26981 3.60003 7.87381 1.33203 13.8018Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6775 30.3466C42.2375 23.9106 36.6615 19.0506 30.2255 19.4906C23.7895 19.9306 18.9295 25.5066 19.3695 31.9426C19.7615 37.6666 24.2535 42.2586 29.9655 42.7786C35.8175 40.6946 40.4655 36.1506 42.6775 30.3466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91211 16.5033C3.91611 22.6313 10.5081 25.9753 16.6361 23.9713C22.7641 21.9673 26.1081 15.3753 24.1041 9.24727C23.0041 5.87927 20.4281 3.19127 17.1121 1.94727C9.67611 3.49527 3.77611 9.14326 1.91211 16.5033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1216 27.5864C40.1656 21.4424 33.5976 18.0464 27.4536 20.0024C21.3096 21.9584 17.9136 28.5264 19.8696 34.6704C20.9896 38.1904 23.7096 40.9704 27.2016 42.1704C34.5336 40.5264 40.3096 34.8824 42.1216 27.5864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35938 17.6343C4.97537 23.5263 11.8714 26.1823 17.7594 23.5663C23.6474 20.9503 26.3074 14.0543 23.6914 8.16629C22.5874 5.68229 20.6514 3.65829 18.2154 2.44629C10.2714 3.68229 3.93937 9.74629 2.35938 17.6343Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6678 26.4417C39.0878 20.5337 32.2078 17.8337 26.2958 20.4137C20.3838 22.9937 17.6878 29.8737 20.2678 35.7857C21.4078 38.3977 23.4638 40.5017 26.0518 41.7057C33.9238 40.3617 40.1438 34.2817 41.6678 26.4417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4959 22.0903C40.4959 32.2703 32.2159 40.5263 21.9999 40.5263C11.7839 40.5263 3.50391 32.2703 3.50391 22.0903C3.50391 11.9103 11.7839 3.6543 21.9999 3.6543C32.2159 3.6543 40.4959 11.9103 40.4959 22.0903Z",
    fill: "url(#paint2_linear_2863_33558)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7727 21.4242C16.0247 20.9322 15.4007 20.2762 14.9487 19.5002C14.5127 18.6842 14.2967 17.7682 14.3247 16.8442C14.2927 15.6722 14.6927 14.5242 15.4487 13.6282C16.2367 12.7282 17.2487 12.0522 18.3807 11.6682C19.6127 11.2322 20.9127 11.0122 22.2207 11.0202C23.0767 11.0122 23.9327 11.0762 24.7767 11.2162C25.3807 11.3082 25.9727 11.4642 26.5487 11.6722C27.0767 11.8522 27.5527 12.1562 27.9367 12.5562C28.2207 12.8882 28.3727 13.3122 28.3647 13.7482C28.3847 14.2042 28.2247 14.6522 27.9127 14.9882C27.6207 15.3002 27.2087 15.4722 26.7807 15.4602C26.4887 15.4562 26.2047 15.3922 25.9407 15.2722C25.2887 14.9802 24.6207 14.7362 23.9367 14.5402C23.3087 14.3722 22.6567 14.2922 22.0047 14.3002C21.1567 14.2682 20.3167 14.4842 19.5847 14.9202C18.9567 15.3002 18.5887 15.9922 18.6207 16.7282C18.6167 17.2002 18.7967 17.6562 19.1207 18.0002C19.5087 18.4042 19.9647 18.7282 20.4727 18.9682C21.0407 19.2482 21.8847 19.6202 23.0047 20.0842C23.1287 20.1242 23.2487 20.1722 23.3687 20.2282C24.4647 20.6602 25.5127 21.2002 26.5047 21.8402C27.2847 22.3482 27.9447 23.0282 28.4367 23.8202C28.9167 24.6562 29.1607 25.6082 29.1327 26.5722C29.1727 27.7522 28.8367 28.9162 28.1687 29.8882C27.4887 30.8122 26.5487 31.5082 25.4687 31.8922C24.1687 32.3562 22.7927 32.5802 21.4087 32.5522C19.5087 32.6202 17.6207 32.2602 15.8767 31.5042C15.4327 31.3042 15.0407 31.0002 14.7367 30.6202C14.4847 30.2682 14.3567 29.8442 14.3647 29.4162C14.3407 28.9562 14.5167 28.5082 14.8527 28.1882C15.1967 27.8842 15.6487 27.7282 16.1087 27.7442C16.6207 27.7522 17.1247 27.8802 17.5767 28.1202C18.1367 28.4002 18.5807 28.6122 18.9047 28.7522C19.2767 28.9082 19.6607 29.0282 20.0527 29.1162C20.5367 29.2242 21.0327 29.2722 21.5247 29.2682C22.4007 29.3322 23.2727 29.1002 24.0007 28.6082C24.5527 28.1762 24.8647 27.5002 24.8367 26.8002C24.8367 26.3082 24.6487 25.8362 24.3127 25.4802C23.8687 25.0202 23.3487 24.6442 22.7727 24.3602C22.0927 24.0042 21.1407 23.5682 19.9127 23.0522C18.8127 22.6202 17.7607 22.0722 16.7727 21.4242Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2863_33558",
    x1: 11.0555,
    y1: 1.44008,
    x2: 14.698,
    y2: 24.4363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#00B7F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#009DE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#0082D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2863_33558",
    x1: 20.8257,
    y1: 37.1628,
    x2: 41.0457,
    y2: 25.4897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#007AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#0082D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#0090DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00A3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2863_33558",
    x1: 14.6895,
    y1: 9.72561,
    x2: 33.1423,
    y2: 41.6864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B7F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007CC1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2863_33558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkype);
export default __webpack_public_path__ + "static/media/skype.164005a94638b08f2212e889895af444.svg";
export { ForwardRef as ReactComponent };